import { Fragment, useState, useEffect } from 'react'
import {
  EuiBasicTable,
  EuiText,
  EuiSpacer,
  EuiHorizontalRule,
  Comparators,
} from '@elastic/eui'

import logService from '../services/log.service'

function AdminUsersLogs() {
  const [logs, setLogs] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const [pageIndex, setPageIndex] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [pageOfItems, setPageOfItems] = useState([])
  const [totalItemCount, setTotalItemCount] = useState(0)
  const [sortField, setSortField] = useState('id')
  const [sortDirection, setSortDirection] = useState('desc')

  const showPerPageOptions = true

  const onTableChange = ({ page = {}, sort = {} }) => {
    const { index: pageIndex, size: pageSize } = page

    const { field: sortField, direction: sortDirection } = sort

    setPageIndex(pageIndex)
    setPageSize(pageSize)
    setSortField(sortField)
    setSortDirection(sortDirection)
  }

  useEffect(() => {
    if (!isLoading) {
      setTotalItemCount(logs.length)
      const startIndex = pageIndex * pageSize
      setPageOfItems(
        logs
          .sort(
            Comparators.property(sortField, Comparators.default(sortDirection)),
          )
          .slice(startIndex, Math.min(startIndex + pageSize, logs.length)),
      )
    }
  }, [logs, isLoading, pageIndex, pageSize, sortField, sortDirection])

  useEffect(() => {
    logService
      .getLogs('user')
      .then(async (response) => {
        console.log('Axios response => ', response)
        const rows = response.data.items
        if (!rows || !rows[0]) {
          setLogs([])
          setIsLoading(false)
        } else {
          setLogs(rows)
          setIsLoading(false)
        }
      })
      .catch((error) => {
        console.log('Axios error => ', error)
      })
  }, [])

  const columns = [
    {
      field: 'id',
      name: 'ID',
      dataType: 'number',
      sortable: true,
    },
    {
      field: 'document.datetime_log',
      name: 'Date',
      dataType: 'string',
      sortable: true,
    },
    {
      field: 'document.username',
      name: 'Username',
      dataType: 'string',
      sortable: true,
    },
    {
      field: 'document',
      name: 'Name',
      dataType: 'string',
      sortable: true,
      render: (document) => {
        return document.lastname + ', ' + document.firstname
      },
    },
    {
      field: 'document.role',
      name: 'Rôle',
      dataType: 'string',
      sortable: true,
    },
  ]

  const sorting = {
    sort: {
      field: sortField,
      direction: sortDirection,
    },
  }

  const pagination = {
    pageIndex,
    pageSize,
    totalItemCount,
    pageSizeOptions: [10, 20, 0],
    showPerPageOptions,
  }

  const resultsCount =
    pageSize === 0 ? (
      <strong>All</strong>
    ) : (
      <>
        <strong>
          {pageSize * pageIndex + 1}-{pageSize * pageIndex + pageSize}
        </strong>{' '}
        of {totalItemCount}
      </>
    )

  return (
    <Fragment>
      <EuiText size="xs">
        Showing {resultsCount} <strong>Users</strong>
      </EuiText>
      <EuiSpacer size="s" />
      <EuiHorizontalRule margin="none" style={{ height: 2 }} />
      <EuiBasicTable
        loading={isLoading}
        items={pageOfItems}
        columns={columns}
        pagination={pagination}
        sorting={sorting}
        tableLayout="auto"
        onChange={onTableChange}
      />
    </Fragment>
  )
}

export default AdminUsersLogs
